import axiosInstance from "axiosConfig";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { toast } from "react-toastify";
import { queryClient } from 'App'
import { SESSION_QUERY_KEY } from './CheckSessionHook'

export type SetNewPasswordPayload = {
  password: string;
  token: string;
};

export const useSetNewPasswordByToken = (
  options?: UseMutationOptions<any, Error, SetNewPasswordPayload>
) => {
  return useMutation({
    mutationKey: ["setNewPasswordByToken"],
    mutationFn: async (payload: SetNewPasswordPayload) => {
      return axiosInstance
        .post(`/successors/change-password/${payload.token}`, {
          password: payload.password,
        })
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        id: "setNewPasswordByToken",
        message: "Ustawianie nowego hasła...",
        type: TOAST_TYPES_ENUM.LOADING,
      });
      if (options?.onMutate) return options.onMutate(variables);
    },
    onSuccess: (data, variables, context) => {
      Toast({
        id: "setNewPasswordByToken",
        message: "Hasło zostało zmienione",
        type: TOAST_TYPES_ENUM.SUCCESS,
      });
      if (options?.onSuccess) options.onSuccess(data, variables, context);
    },
    onError: (error: any, variables, context) => {
      queryClient.invalidateQueries({ queryKey: SESSION_QUERY_KEY })
      
      if (error?.status === 422) {
        if(error?.data?.message === "You can't set the same password as the current one") {
          Toast({
            id: "setNewPasswordByToken",
            message: "Hasło nie może być takie samo jak poprzednie",
            type: TOAST_TYPES_ENUM.ERROR,
          });
        } else {
          Toast({
            id: "setNewPasswordByToken",
            message: "Nieprawidłowe dane",
            type: TOAST_TYPES_ENUM.ERROR,
          });
        }
      } else if (error?.status === 500) {
        Toast({
          id: "setNewPasswordByToken",
          message: "Błąd serwera",
          type: TOAST_TYPES_ENUM.ERROR,
        });
      } else {
        toast.dismiss("setNewPasswordByToken");
      }

      if (options?.onError) options.onError(error, variables, context);
    },
  });
};
